import React from 'react';
import recordEvent from 'platform/monitoring/record-event';
import { VRE_TRACKER_PATH } from '../constants';

export default function VreBenefitsSection() {
  const recordLinkClick = () =>
    recordEvent({
      event: 'nav-link-click',
      'link-label': 'Track your VR&E benefits',
      'link-destination': VRE_TRACKER_PATH,
    });

  return (
    <div className="vads-u-margin-y--4">
      <h2 id="your-vre-benefits">Your VR&E benefits</h2>
      <va-link
        active
        disable-analytics
        href={VRE_TRACKER_PATH}
        text="Track your VR&E benefits"
        onClick={recordLinkClick}
      />
      <p className="vads-u-margin-y--0p5">
        Check the status of your Veteran Readiness and Employment (VR&E)
        application and benefits.
      </p>
    </div>
  );
}
